<mat-form-field class="page-selector" *ngIf="items$ | async as items">
  <mat-select
    [formControl]="selectFormControl"
    [placeholder]="placeholder"
    [compareWith]="compareFunction"
    (closed)="propagateTouch()"
    [errorStateMatcher]="errorLabel !== undefined ? alwaysError : undefined"
    [class.loading]="isLoading$ | async"
  >
    <mat-select-trigger>
      {{ selectFormControl.value?.name }}
    </mat-select-trigger>
    <mat-option>
      <ngx-mat-select-search
        [formControl]="inputFormControl"
        placeholderLabel="Search..."
        noEntriesFoundLabel="No items found"
        [clearSearchInput]="false"
        data-testid="page-selector-search-input"
      >
        <svg-icon ngxMatSelectSearchClear key="cancel"></svg-icon>
      </ngx-mat-select-search>
    </mat-option>

    <mat-option ngDefaultControl [value]="null">None</mat-option>

    <mat-option *ngFor="let page of items" [value]="page">
      <div class="search-option">
        <span>{{ page.internalName }}</span>
        <span>{{ page.name }}</span>
        <span>{{ page.lastPublishedAt | date: 'dd/MM/yyyy HH:mm z' }}</span>
        <span>{{ page.status }}</span>
      </div>
    </mat-option>
  </mat-select>
  <mat-label *ngIf="label">{{ label }}</mat-label>
  <mat-error *ngIf="errorLabel !== undefined">{{ errorLabel }}</mat-error>
  <mat-hint *ngIf="hintLabel" class="page-selector__hint">{{ hintLabel }}</mat-hint>
</mat-form-field>
